// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/InstagramAccounts_SalvarFranquiasInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /instagram/accounts/salvar_franquias
 *
 * Updates franchise associations for an Instagram account.
 */
import { registerContract } from './validate'

export interface InstagramAccounts_SalvarFranquiasInput {
instagram_account_id: number
franquia_ids: number[]
}

registerContract('InstagramAccounts_SalvarFranquiasInput', {
  instagram_account_id: { type: 'number',  required: true },
  franquia_ids:         { type: 'array',   required: true },
})
